
import React from 'react';
import { CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Rotate3D } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface FlashcardFrontProps {
  content: string;
  onFlip: () => void;
}

const FlashcardFront: React.FC<FlashcardFrontProps> = ({
  content,
  onFlip
}) => {
  const { isMobile } = useIsMobile();
  
  return (
    <CardContent className="h-full flex flex-col items-center justify-center p-4 sm:p-6 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30">
      <div className="text-center max-w-full overflow-auto flex-1 flex items-center justify-center">
        <p className={`${isMobile ? 'text-base' : 'text-lg'} font-medium whitespace-pre-line bg-gradient-to-br from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400 bg-clip-text text-transparent`}>
          {content}
        </p>
      </div>
      <Button 
        variant="ghost" 
        size={isMobile ? "sm" : "sm"} 
        className={`mt-3 sm:mt-4 text-blue-600 hover:text-blue-700 hover:bg-blue-50 dark:text-blue-400 dark:hover:text-blue-300 dark:hover:bg-blue-900/30 ${isMobile ? 'w-full justify-center' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          onFlip();
        }}
      >
        <Rotate3D className="h-4 w-4 mr-2" />
        Flip Card
      </Button>
    </CardContent>
  );
};

export default FlashcardFront;
